var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetterG(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6463,
    cy: 11.8821,
    r: 11.3821,
    fill: "#F0F3F9",
    stroke: "#8194D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.044 16.182C10.757 16.182 9.704 15.74 8.885 14.856C8.066 13.972 7.65 12.854 7.65 11.489C7.65 10.124 8.066 8.993 8.898 8.109C9.717 7.225 10.77 6.783 12.057 6.783C14.189 6.783 15.554 7.823 16.035 9.695L14.969 10.033C14.566 8.512 13.591 7.758 12.057 7.758C11.108 7.758 10.328 8.109 9.717 8.798C9.106 9.5 8.807 10.397 8.807 11.489C8.807 12.62 9.119 13.517 9.743 14.193C10.367 14.869 11.16 15.207 12.122 15.207C12.98 15.207 13.734 14.921 14.371 14.349C15.008 13.777 15.333 12.997 15.372 11.996H12.226V11.021H16.425V16H15.372V14.362C14.709 15.545 13.461 16.182 12.044 16.182Z",
    fill: "#657CCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterG);
export default __webpack_public_path__ + "static/media/letterG.2749cd71b72d5af41e44711818902117.svg";
export { ForwardRef as ReactComponent };